import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface HelpModeContextType {
  helpMode: boolean;
  toggleHelpMode: () => void;
}

const HelpModeContext = createContext<HelpModeContextType>({
  helpMode: false,
  toggleHelpMode: () => {},
});

function getStored(): boolean {
  try {
    return localStorage.getItem('pm_help_mode') === 'true';
  } catch {
    return false;
  }
}

export function HelpModeProvider({ children }: { children: ReactNode }) {
  const [helpMode, setHelpMode] = useState(getStored);

  const toggleHelpMode = useCallback(() => {
    setHelpMode((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('pm_help_mode', String(next));
      } catch { /* noop */ }
      return next;
    });
  }, []);

  return (
    <HelpModeContext.Provider value={{ helpMode, toggleHelpMode }}>
      {children}
    </HelpModeContext.Provider>
  );
}

export function useHelpMode() {
  return useContext(HelpModeContext);
}
